<template>
	<div>
		<div class="foot-tab" :class="{'!rounded-b-none' : noCorners}">
			<div class="foot-tab-head">
				<div class="foot-tab-row-label">
					<span class="cursor-pointer zt-hover underline min-w-[18px] whitespace-nowrap pl-[10px]"
                @click="sortAscending = sortAscending === 0 ? 1 : 0; isLpSet = !isLpSet">L.p</span>
					<span class="cursor-pointer zt-hover underline truncate"
					      :class="{ '!no-underline' : sortColumn === 'name' }"
					      @click="sortTable('name', $event)">{{ getTitleString(phaseString) }}</span>
				</div>
        <div class="flex">
          <div class="foot-tab-row-item"
               :class="{ '!no-underline' : sortColumn === 'matches' }"
               @click="sortTable('matches', $event)"><div>M</div></div>
          <div class="foot-tab-row-item"
               :class="{ '!no-underline' : sortColumn === 'cardsObtained' }"
               @click="sortTable('cardsObtained', $event)"><div>DLA</div></div>
          <div class="foot-tab-row-item !w-[50px]"
               :class="{ '!no-underline' : sortColumn === 'cardsLost' }"
               @click="sortTable('cardsLost', $event)"><div>RYWAL</div></div>
          <div class="foot-tab-row-item !w-[50px]"
               :class="{ '!no-underline' : sortColumn === 'avgCards' }"
               @click="sortTable('avgCards', $event)"><div>Śr</div></div>
        </div>
			</div>
			<div class="foot-tab-row" :class="{ '!bg-zt-more/35' : selectedTeamsIds.includes(+team.team_id), '!border-b-0 !rounded-b-zt': index === leagueTable.length - 1 }"
           v-for="(team, index) in leagueTable" :key="team.team_id">
				<div class="foot-tab-row-label" :class="{ '!bg-[#4d5a6d]' : selectedTeamsIds.includes(+team.team_id) }">
					<p class="flex items-center">
						<span class="inline-block w-[22px] !shrink-0">{{isLpSet ?  leagueTable.length - index : index + 1}}.</span>
            <a v-if="!selectedTeamsIds.includes(+team.team_id)"
               :href="team.clickable ? `/wyniki-pilka-nozna/druzyny/${team.query_name}/` : null"
               class="no-default-style" :class="{ 'zt-hover': team.clickable }">
              <span class="flex items-center mr-2 aspect-square h-5">
                <TeamImg :team="team"/>
              </span>
            </a>
            <span v-else class="flex items-center mr-2 aspect-square h-5">
              <TeamImg :team="team"/>
            </span>
						<a v-if="!selectedTeamsIds.includes(+team.team_id)"
               class="no-default-style text-ellipsis line-clamp-1 break-all" :class="{ 'zt-hover': team.clickable }"
               :href="team.clickable ? `/wyniki-pilka-nozna/druzyny/${team.query_name}/` : null">
              {{ team.short_name?.length > 0 ? team.short_name : team.name }}
            </a>
						<span v-else class="text-ellipsis line-clamp-1 break-all">
              {{ team.short_name?.length > 0 ? team.short_name : team.name }}
            </span>
					</p>
				</div>
        <Transition appear name="fade" mode="out-in">
          <div :key="filterKey" class="flex">
            <div class="foot-tab-row-item" :class="{ 'foot-tab-row-item-active' : sortColumn === 'matches' }">
              <div>{{ allMatches(team) }}</div>
            </div>
            <div class="foot-tab-row-item" :class="{ 'foot-tab-row-item-active' : sortColumn === 'cardsObtained' }">
              <div>{{ cardsObtained(team) }} </div>
            </div>
            <div class="foot-tab-row-item !w-[50px]" :class="{ 'foot-tab-row-item-active' : sortColumn === 'cardsLost' }">
              <div>{{ cardsLost(team) }} </div>
            </div>
            <div class="foot-tab-row-item !w-[50px]" :class="{ 'foot-tab-row-item-active' : sortColumn === 'avgCards' }">
              <div>{{ avgCards(team) }} </div>
            </div>
          </div>
        </Transition>
			</div>
		</div>
	</div>
</template>

<script>
import TeamImg from '../football_stats/blocks/TeamImg.vue';
import football_mixin from '../../mixins/football_mixin';

export default {
	name: 'CardsTable',
	components: { TeamImg },
  mixins: [football_mixin],
	inject: ['WP'],
	props: {
    noCorners: {
      type: Boolean,
      default: false,
    },
    phase: {
      type: String,
      default: '',
    },
		teams: Array,
		filters: Array,
		details: Object,
		leagueId: String,
		selectedTeamsIds: {
			type: Array,
			default: [],
		},
    view: {
      type: String,
      default: 'normal',
      validator: function (value) {
        return ['normal', 'compact'].includes(value);
      }
    }
	},
	data() {
		return {
			previousSortColumn: null,
			sortColumn: 'avgCards',
			isLpSet: false,
			sortAscending: 0,
			displayedTable: 'all',
			currentCardColor: this.filters[1] ?? 'yellow',
			currentSubTab: this.filters[2] ?? 'all',
			teamsSorted: [],
			filtersChanged: 0
		}
	},
  mounted() {
		this.teamsSorted = this.teams;
	},
	computed: {
    rowHeight() {
      return this.view === 'compact' ? '28px' : '38px';
    },
    legendBarHeight() {
      return this.view === 'compact' ? '19px' : '30px';
    },
    filterKey() {
      return this.filters.join('-') + `-${ this.view }`;
    },
    phaseString() {
      return this.phase.replace('_', ' ');
    },
		leagueTable() {
			if (this.teamsSorted && this.teamsSorted.length > 0) {
				return this.teamsSorted.slice().sort(this.sortTeams);
			}	else {
				return [];
			}
		},
	},
	watch: {
		filters(newVal) {
			if (this.filtersChanged === 0) {
				this.currentSubTab = newVal[2];
				this.currentCardColor = newVal[1];
			} else {
				setTimeout(() => {
					this.currentSubTab = newVal[2];
					this.currentCardColor = newVal[1];
				}, 250);
			}
			this.filtersChanged++;
		},
	},
	methods: {
		sortTable(column, event) {
			let eventTarget;
			if (event.target.tagName === 'DIV') {
				eventTarget = event.target;
			} else {
				eventTarget = event.target.parentElement.parentElement;
			}
			if (column !== this.sortColumn) {
				this.sortAscending = 0;
				this.sortColumn = column;
			} else {
				this.sortAscending = !this.sortAscending;
			}
			this.previousSortColumn = eventTarget;
		},
		allMatches(team) {
			if (this.currentSubTab === 'all') {
				return team.all_matches;
			} else if (this.currentSubTab === 'home') {
				return team.local_matches;
			} else {
				return team.visitor_matches;
			}
		},
		sortTeams(a, b) {
			let diff = 0;
			if (this.sortColumn === 'name') {
				if (this.sortAscending) {
					diff = a.name.localeCompare(b.name);
				} else {
					diff = b.name.localeCompare(a.name);
				}
				return diff;
			}
			switch (this.sortColumn) {
				case 'matches':
					if (this.sortAscending) {
						diff = this.allMatches(a) - this.allMatches(b);
					} else {
						diff = this.allMatches(b) - this.allMatches(a);
					}
					break;
				case 'cardsObtained':
					if (this.sortAscending) {
						diff = parseFloat(this.cardsObtained(a)) - parseFloat(this.cardsObtained(b));
					} else {
						diff = parseFloat(this.cardsObtained(b)) - parseFloat(this.cardsObtained(a));
					}
					break;
				case 'cardsLost':
					if (this.sortAscending) {
						diff = parseFloat(this.cardsLost(a)) - parseFloat(this.cardsLost(b));
					} else {
						diff = parseFloat(this.cardsLost(b)) - parseFloat(this.cardsLost(a));
					}
					break;
				case 'avgCards':
				default:
					if (this.sortAscending) {
						diff = parseFloat(this.avgCards(a)) - parseFloat(this.avgCards(b));
					} else {
						diff = parseFloat(this.avgCards(b)) - parseFloat(this.avgCards(a));
					}
					break;
			}
			return diff;
		},
		cardsObtained(team) {
			return team.cards[this.currentCardColor].obtained[this.currentSubTab];
		},
		cardsLost(team) {
			return team.cards[this.currentCardColor].lost[this.currentSubTab];
		},
		avgCards(team) {
			let avg = 0;
			if (this.currentSubTab === 'all') {
				avg = team.all_matches > 0 ? ((team.cards[this.currentCardColor].lost.all + team.cards[this.currentCardColor].obtained.all) / team.all_matches).toFixed(this.currentCardColor === 'yellow' ? 1 : 2) : 0;
			} else if (this.currentSubTab === 'home') {
				avg = team.all_matches > 0 ? ((team.cards[this.currentCardColor].lost.home + team.cards[this.currentCardColor].obtained.home) / team.local_matches).toFixed(this.currentCardColor === 'yellow' ? 1 : 2) : 0;
			} else {
				avg = team.all_matches > 0 ? ((team.cards[this.currentCardColor].lost.away + team.cards[this.currentCardColor].obtained.away) / team.visitor_matches).toFixed(this.currentCardColor === 'yellow' ? 1 : 2) : 0;
			}
			return isNaN(avg) ? '0.00' : avg;
		},
	}
}
</script>
<style scoped>
.foot-tab-row-item {
  height: v-bind(rowHeight);
}

.foot-tab-row {
  height: v-bind(rowHeight);
}

.foot-tab-row-marked-red::before, .foot-tab-row-marked-red-variant::before,
.foot-tab-row-marked-blue::before, .foot-tab-row-marked-blue-variant::before,
.foot-tab-row-marked-purple::before, .foot-tab-row-marked-purple-variant::before,
.foot-tab-row-marked-green::before, .foot-tab-row-marked-green-variant::before {
  height: v-bind(legendBarHeight);
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>